/** Initial wizard state — mirrors DQProProgCreationV2 */
export const WIZARD_INITIAL_STATE = {
    UseTemplate: false,   // Whether to use the template or start from scratch
    Title: "",   // Program title confirmed by the AI (from {{theme=}} marker)
    Theme: "",   // Competency theme description (from {{detected_competencies=}} marker)
    Competencies: [],
    Age: '',
    Tier: null,   // Audience tier "T1".."T7" from the DQ AI interview; the ML engine prefers it over Age
    Countries: '',
    SelectedFrameList: [],
    ContentLanguages: [],
    CurriculumType: '',
    SubjectArea: null,
    SubjectAreaOther: null,
    SubjectContextTopic: '',
    StructureType: null,
    SessionDuration: null,
    NumSessions: null,
    SuggestApproxHours: null,
    FocusProblem: null,
    FocusSolution: null,
    FocusMindset: null,
    FocusKS_F: null,
    FocusKS_C: null,
    FocusKS_P: null,
    FocusKS_M: null,
    FocusAB_A: null,
    FocusAB_P: null,
    FocusAB_I: null,
    FocusAB_B: null,
    ExposureTopic: null,
    ExposureTopicDetail: null,
    Format: [0, 0, 0, 0, 0, 0, 0],
    FormatOther: null,
    TechEnvironment: null,
    BestDelivery: [0,0,0,0,0,0,0,0,0],
    BestDeliveryOther: null,
    CulturalSensitivity: [0,0,0,0,0,0],
    CulturalSensitivityOther: null,
    ContentStyle: ' ',
    CulturalSensitivityDetails: null,
    Activities: null,
};

// true for LOCAL (.env.local) and DEVELOP (.env.develop); false for STAGE and LIVE.
export const _isDevEnv = process.env.REACT_APP_NAME === 'LOCAL' || process.env.REACT_APP_NAME === 'DEVELOP';

/** Sensible defaults applied before calling buildLearningProgramService */
export const DEFAULT_WIZARD_VALUES = {
    UseTemplate: _isDevEnv,
    Theme: 'The user is interested in developing a global mindset and cultural sensitivity to effectively engage as a global digital citizen.',
    Competencies: ['DQ_IND_01_01'],
    Age: '13-14YO',
    Countries: 'AU',
    SelectedFrameList: [],
    ContentLanguages: [],
    CurriculumType: 2,
    SubjectArea: null,
    SubjectAreaOther: null,
    SubjectContextTopic: '',
    StructureType: 2,
    SessionDuration: 25,
    NumSessions: 1,
    SuggestApproxHours: 25,
    FocusProblem: 3,
    FocusSolution: 3,
    FocusMindset: 2,
    FocusKS_F: 3,
    FocusKS_C: 2,
    FocusKS_P: 2,
    FocusKS_M: 2,
    FocusAB_A: 3,
    FocusAB_P: 2,
    FocusAB_I: 2,
    FocusAB_B: 2,
    ExposureTopic: 2,
    ExposureTopicDetail: '',
    Format: [0, 1, 0, 0, 0, 0, 0],
    FormatOther: null,
    TechEnvironment: 3,
    BestDelivery: [6],
    BestDeliveryOther: '',
    CulturalSensitivity: [0, 1, 0, 0, 0, 0],
    CulturalSensitivityOther: '',
    CulturalSensitivityDetails: '',
    ContentStyle: '2D_Vector_Flat',
    CourseCode: '',
    Activities: null,
};

export const BUILD_MESSAGES = {
    STEP1_BASE: 'Step 1: Building your curriculum and learning program content for your students with videos, slides, and activities so that they can learn...',
    STEP2_BASE: 'Step 2: Building your curated assessment so that you can diagnose students...',
    STEP3_TEXT: 'Step 3: Building your metrics dashboard to visualize impact and monitor progress...100%',
    FINAL_TEXT: 'Did you know that you can change the graphic style (ie. watercolor, illustration, 3D cartoon, clay, etc.)? Or fit cultural regions or communities better like make this program for kids in California. There are also PRO features that you can access that allow you to add:\n\u2022 different languages\n\u2022 align to specific international standards or frameworks\n\u2022 edit individual content slides\n\nLet me know what you want to do!'
};

export const DUMMY_MODULES = [
    {
        module_title: "AI Ethics",
        units: [
            {
                unit_title: "Introduction to AI",
                sessions: [
                    { session_title: "Session 1", session_code: "S1" },
                    { session_title: "Session 2", session_code: "S2" },
                    { session_title: "Session 3", session_code: "S3" }
                ]
            },
            {
                unit_title: "Responsible AI",
                sessions: [
                    { session_title: "Session 1", session_code: "S4" }
                ]
            }
        ]
    }
];

export const PREVIEW_TABS = [
    { id: 1, label: "Learning Content" },
    { id: 2, label: "Assessment" },
    { id: 3, label: "Impact Dashboard" },
    { id: 4, label: "Program Outline" }
];
